"use client";

import React, { useContext, useEffect, useState } from "react";
import { BlogList } from "./BlogList";
import { usePathname } from "next/navigation";
import CategoryList from "./CategoryList";
import MarioLoader from "./MarioLoader";
import Image from "next/image";
import Mainlogo from "../../../public/BlogHeadLogo.webp";
import MyContext from "../Context/MyContext";


const Blogs = () => {
    const [FilteredBlogList, setFilteredBlogList] = useState([]);
    const [ifFilterBloge, setIfFilterBlog] = useState(false);

    const [tagList, setTagList] = useState([]);

    const currentPage = usePathname();
    const search = currentPage.split("/")[3];

    const { blogList, loadings } = useContext(MyContext);


    useEffect(() => {
        if (blogList && search) {
            const filteredBlogs = blogList.filter((blog) =>
                blog.attributes.tags.data.some(
                    (tag) =>
                        tag.attributes.uid.toLowerCase() ===
                        search.toLowerCase()
                )
            );

            if (filteredBlogs.length <= 0) {
                setIfFilterBlog(true);
            }
            setFilteredBlogList(filteredBlogs);
        } else {
            setFilteredBlogList([]);
        }
    }, [search, blogList]);

    useEffect(() => {
        if (blogList.length > 0) {
            const allTags = blogList
                .flatMap((blog) => blog.attributes.tags?.data || [])
                .map((tag) => ({
                    name: tag.attributes.name,
                    uid: tag.attributes.uid,
                }));

            // Remove duplicate tags
            const uniqueTags = Array.from(
                new Map(allTags.map((tag) => [tag.uid, tag])).values()
            );

            setTagList(uniqueTags);
        }
    }, [blogList]);

    return (
        <>
            <div className="flex flex-col w-full min-h-screen">
                <div className="flex flex-col items-center w-full place-content-center text-white">
                    <div className="w-full py-32 bg-[url('https://res.cloudinary.com/drmbdzyon/image/upload/v1749718707/BlogMainBackground.webp')] bg-cover bg-center h-[69vh]">
                        <div className="grid place-items-center w-full gap-3 text-md sm:px-5 xl:px-0 h-[50vh]">
                            <div className="md:max-w-md lg:max-w-lg 2xl:max-w-2xl grid place-items-center space-y-10 mx-3 md:mx-0">
                                <Image
                                    rel="preload" 
                                    src={Mainlogo}
                                    alt="website_logo"
                                    className="cursor-pointer w-80 xl:w-96 2xl:w-[400px]"
                                />
                                <p className="text-center text-lg md:text-xl 2xl:text-[22px]">
                                    {`Powering Web3 with industry-leading blockchain services ⚡️ Build and Scale your app with fast, Quality code, reliable APIs & tooling across 60+ blockchains 🌎`}
                                </p>

                                <p className="text-white hover:text-gray-400 cursor-pointer w-fit my-3">
                                    <a
                                        href="https://wa.me/+916354953278"
                                        target="_blank"
                                        className="text-sm lg:text-lg common-white-button-style"
                                    >
                                        {"Contact Us"}
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {loadings ? (
                    <div className="flex justify-center items-center aligncenter my-5">
                        <MarioLoader />
                    </div>
                ) : (
                    <div className="2xl:mx-96 xl:mx-[360px] lg:mx-20 md:mx-10 mx-5">
                        <div className="flex flex-col items-center w-full px-3 my-5 ">
                            <CategoryList
                                tags={tagList}
                                activeTags={search}
                                FilteredBlogList={FilteredBlogList}
                                setFilteredBlogList={setFilteredBlogList}
                                blogList={blogList}
                                setIfFilterBlog={setIfFilterBlog}
                            />
                        </div>

                        <div className="flex flex-col items-center w-full mb-7">
                            {FilteredBlogList.length <= 0 ? (
                                ifFilterBloge ? (
                                    <div className="text-3xl font-bold">
                                        No Data Found
                                    </div>
                                ) : (
                                    <BlogList blogList={blogList} />
                                )
                            ) : (
                                <BlogList blogList={FilteredBlogList} />
                            )}
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Blogs;
